import { call, put, takeLatest } from "redux-saga/effects";
import { subsidiariesAPI } from "../api/api";
import { SubsidiariesActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() =>
            subsidiariesAPI.getSubsidiaries()
        );

        yield put({
            type: SubsidiariesActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: SubsidiariesActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(SubsidiariesActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
